import { useState } from 'react';
import { useCurrencySymbol } from '@shared/hooks';
import type { Recipient } from '@shared/api/rest/alerts';
import { AccountSidebarItems } from './accountSidebarItems';
import { ModalEditDetails } from './modalEditDetails';
import { ChangeAlertModal } from './changeAlertModal';
import { EditRecipientsModal } from './editRecipientsModal';
import { $accountByIdStore } from '@lib/store';
import { useUnit } from 'effector-react';

export const AccountSidebar = () => {
  const accountDetailsStore = useUnit($accountByIdStore.store);
  const account = accountDetailsStore.data;

  const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
  const [showModalChangeAlert, setShowModalChangeAlert] = useState<boolean>(false);
  const [showModalEditRecipients, setShowModalEditRecipients] = useState<boolean>(false);

  const symbol = useCurrencySymbol(account?.currency);

  if (!account) return null;
  return (
    <>
      <div className='p-6 w-80 bg-white dark:bg-soft-black'>
        <AccountSidebarItems
          openEditModal={() => setShowModalEdit(!showModalEdit)}
          openChangeAlertModal={() => setShowModalChangeAlert(true)}
          openEditRecipientsModal={() => setShowModalEditRecipients(true)}
          account={account}
        />
      </div>
      <ModalEditDetails
        show={showModalEdit}
        onClose={() => setShowModalEdit(false)}
        account={account}
        initial={{ label: account.accountLabel, costCentre: account.costCentre, category: account.category }}
      />
      <ChangeAlertModal
        show={showModalChangeAlert}
        onClose={() => setShowModalChangeAlert(false)}
        symbol={symbol}
        account={account}
        initialValue={account.minimalBalanceAlertSubscription?.minimalBalance}
        initialRecipients={account.minimalBalanceAlertSubscription?.recipientDetails as unknown as Recipient[]}
        subId={account.minimalBalanceAlertSubscription?.subscriptionId}
      />
      <EditRecipientsModal
        show={showModalEditRecipients}
        onClose={() => setShowModalEditRecipients(false)}
        accountId={account.id}
        recipients={account.declinedAuthorizationSubscription?.recipientDetails as unknown as Recipient[]}
        subId={account.declinedAuthorizationSubscription?.subscriptionId}
      />
    </>
  );
};
